module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/makeup@3x_0fbb23.png";